module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/discover/BMW_eShop_new.jpg?eda07aded41952387dd947e4c7b8aa8f";